// extracted by mini-css-extract-plugin
export default {"wrapper":"GuideItem_wrapper__AT7kd","heading":"GuideItem_heading__NRbps","description":"GuideItem_description__SchDz","link":"GuideItem_link__2QK7w"};